import { TValidator } from "../../../../wizard/types";
import { HTMLTagRegEx } from "../../../../../constants";
import { courseDetailsConfig } from "../../../constants";
import { CourseDetailType } from "../../../types";

type CommonObject = { [key: string]: any };

const requiredTypes: CourseDetailType[] = courseDetailsConfig
  .filter((config) => config.isRequired)
  .map((config) => config.type);

const validator: TValidator = async ({ values, activeStepName }) => {
  const errors: CommonObject = {
    details: {},
  };

  const details = values[activeStepName]?.details || {};

  requiredTypes.forEach((type) => {
    if (
      !details[`type_${type}`] ||
      !details[`type_${type}`].replace(HTMLTagRegEx, "").trim().length
    ) {
      errors.details[`type_${type}`] = "This field is required.";
    }
  });

  if (Object.keys(errors.details).length > 0) {
    throw {
      [activeStepName]: errors,
    };
  }
};

export default validator;
